import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CustomersService } from "../../customer.service"
import { CustomerRoom } from 'app/main/model/ProjectOffer';
import { RequestProjectCustomerRoom } from 'app/main/model/RequestBase';
import { ResponseBase } from 'app/main/model/ResponseBase';
import { NotificationsService } from 'angular2-notifications';
import { CommonService } from 'app/core/services/common.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'vibe-customerRooms',
    templateUrl: './customerRooms.component.html',
})
export class CustomerRoomsComponent implements OnInit {
    @Input() PropertyInput: any;
    @Output() GoToBack: EventEmitter<boolean> = new EventEmitter();

    showSpinner = false;
    CustomerRooms: CustomerRoom[] = [];
    requestProjectCustomerRoom: RequestProjectCustomerRoom = new RequestProjectCustomerRoom();
    RemoveRoomByIndex: number;

    //Initiators
    constructor(
        private customersService: CustomersService,
        private notificationsService: NotificationsService,
        private commonService: CommonService,
        private translate: TranslateService,
    ) {
    }

    ngOnInit() {        
        if(this.PropertyInput) {
            this.GetCustomerRoomList(true)
        }
    }

    GetCustomerRoomList(evt) {
        if(evt) {
            this.showSpinner = true;
            this.requestProjectCustomerRoom.Limit = 100;
            this.requestProjectCustomerRoom.CustomerPropertyID = this.PropertyInput;
            this.customersService.GetCustomerPropertyRooms<ResponseBase>(this.requestProjectCustomerRoom)
                .subscribe((response: ResponseBase) => {
                    this.showSpinner = false;
                    this.CustomerRooms = []
                    if (response != null) {
                        this.CustomerRooms = response.result;
                    }
                },
                error => (err) => {
                    this.showSpinner = false;
                    this.translate.get("MESSAGES.Failed").subscribe({
                        next: (res) => {
                            this.notificationsService.error(res);
                        },
                        error: err => {
                        }
                    });
                });
        }
    }

    DeleteCustomerRoom(obj) {
        let roomId = obj.roomId;
        let rowIndex = obj.rowIndex;
        
        this.showSpinner = true;
        this.customersService.DeleteCustomerPropertyRoom<ResponseBase>(roomId)
            .subscribe((response: ResponseBase) => {
                this.showSpinner = false;
                if(response.statusCode==200) {
                    this.translate.get('MESSAGES.Deleted').subscribe({
                        next: (res) => {
                            this.notificationsService.create(res);
                        },
                        error: err => {
                        }
                    });
                    this.GetCustomerRoomList(true);
                    this.RemoveRoomByIndex = rowIndex;
                } else {
                    this.translate.get("MESSAGES.Failed").subscribe({
                        next: (res) => {
                            this.notificationsService.error(res);
                            this.commonService.playFailedTone();
                        },
                        error: err => {
                        }
                    });
                }
            },
            error => (err) => {
                this.showSpinner = false;
                this.translate.get("MESSAGES.Failed").subscribe({
                    next: (res) => {
                        this.notificationsService.error(res);
                    },
                    error: err => {
                    }
                });
            });
    }

    AddProjectOffer(list:CustomerRoom[]) {
        list.forEach(i => {
            i.CustomerPropertyID = this.PropertyInput
        })
        this.customersService.AddUpdateCustomerPropertyRoom<ResponseBase>(list)
            .subscribe((response: ResponseBase) => {
                this.showSpinner = false;
                if (response != null) {
                    if (response.result.length) {
                        this.GetCustomerRoomList(true);
                    }
                    //this.OfferOutput.emit(this.projectOffer.id);
                    this.translate.get("MESSAGES.Success").subscribe({
                        next: (res) => {
                            this.notificationsService.success(res);
                        },
                        error: err => {
                        }
                    });
                }
                else {
                    this.translate.get("MESSAGES.Failed").subscribe({
                        next: (res) => {
                            this.notificationsService.error(res);
                            this.commonService.playFailedTone();
                        },
                        error: err => {
                        }
                    });
                }
            },
            error => (err) => {
                this.showSpinner = false;
                this.translate.get("MESSAGES.Failed").subscribe({
                    next: (res) => {
                        this.notificationsService.error(res);
                    },
                    error: err => {
                    }
                });
            });
    }

    GoToPropertyList() {
        this.GoToBack.emit(true)
    }

}
